import { createStore } from 'satcheljs';
import ReadWriteRecipientWellStore from './schema/ReadWriteRecipientWellStore';
import '../orchestrators/removePersonaFromWellOrchestrator';
import '../orchestrators/removeRecipientsFromRecipientWellsOrchestrator';
import '../orchestrators/addReadWriteRecipientsOrchestrator';

var initialReadWriteRecipientWellStore: ReadWriteRecipientWellStore = {
    pendingFindPeopleRequests: 0,
};
var store = createStore<ReadWriteRecipientWellStore>(
    'readwriterecipientwell',
    initialReadWriteRecipientWellStore
)();

export default store;
